<div class="position-absolute bottom-7 start-20">
  <app-scale-control> </app-scale-control>
</div>
<div
  class="position-absolute translate-middle-x bottom-7 start-50 col"
  [class.d-none]="allowedFilters.length <= 1"
  data-cy="dropdown-warnings-menu"
>
  <div isDemoEnabled ngbDropdown placement="top" class="d-inline-block z-5">
    <button
      type="button"
      class="customer-page-panel customer-page-button btn btn-outline-primary z-5 shadow-sm rounded-2 cursor-pointer border hover-effect"
      id="dropdownBasic1"
      ngbDropdownToggle
      data-cy="dropdown-warnings-toggle"
    >
      {{ this.currentFilter.split('.')[1] }}
    </button>
    <div
      isDemoEnabled
      ngbDropdownMenu
      class="customer-page-panel customer-page-menu z-5 shadow-sm rounded-2 cursor-pointer border hover-effect"
      aria-labelledby="dropdownBasic1"
      dropdownWarningsToggle
    >
      <div *ngFor="let filter of allowedFilters">
        <button
          ngbDropdownItem
          class="customer-page-menu-item z-5 rounded-2 hover cursor-pointer"
          (click)="setCurrentFilter(filter)"
          data-cy="dropdown-warnings-item"
        >
          {{ filter }}
        </button>
      </div>
    </div>
  </div>
</div>
<app-bottom-page-panel>
  <app-history-mode
    *hasPermissionAny="[Permissions.RCS_Historic_All_Read, Permissions.RCS_Historic_Warnings_Read]"
    [isHistoryVisible]="isHistoryVisible"
    (historyToggled)="toggleHistory()"
    data-cy="historic-view-toggle"
  ></app-history-mode>
  <app-auto-refresh
    (intervalSet)="setLiveModeRefreshInterval($event)"
    [isActive]="isInLiveMode"
    [isDisabled]="isHistoryVisible"
    [intervalInSecondsInput]="displayRefreshInterval"
  ></app-auto-refresh>
</app-bottom-page-panel>
<app-map-navigation>
  <app-customer-view-actions-bar
    [isDownloadVisible]="isDownloadVisible"
    (toggleDownload)="toggleDownload()"
  ></app-customer-view-actions-bar>
</app-map-navigation>
@if (isHistoryVisible) {
  <app-customer-history-control
    (historyClosed)="handleHistoryClosed()"
  ></app-customer-history-control>
}
@if (isDownloadVisible) {
  <app-customer-download-control
    (historyClosed)="handleDownloadClosed()"
  ></app-customer-download-control>
}
<app-customer-layer-config [isHistoryVisible]="isHistoryVisible"></app-customer-layer-config>
<app-customer-warnings-details></app-customer-warnings-details>
<app-last-backend-call></app-last-backend-call>
